/**
 * Light theme — Roomgrid design system.
 * All tokens and overrides live in ./roomgrid.ts (shared with darkTheme).
 */

import { buildRoomgridTheme } from "./roomgrid";

export const lightTheme = buildRoomgridTheme("light");

export default lightTheme;
